// src/utils/localStorageUtils.js

export const saveDataToLocal = (key, data) => {
  try {
    localStorage.setItem(key, JSON.stringify(data));
    console.log(`✅ Saved ${key} to localStorage (${JSON.stringify(data).length} chars)`);
  } catch (error) {
    console.error(`❌ Error saving ${key} to localStorage:`, error);
  }
};

export const getDataFromLocal = (key) => {
  try {
    const data = localStorage.getItem(key);
    if (data) {
      const parsed = JSON.parse(data);
      console.log(`✅ Loaded ${key} from localStorage (${data.length} chars)`);
      return parsed;
    }
    console.log(`ℹ️ No data found for ${key}, returning empty array`);
    return [];
  } catch (error) {
    console.error(`❌ Error loading ${key} from localStorage:`, error);
    return [];
  }
};

export const addDataToLocal = (key, newItem, idField) => {
  try {
    const existingData = getDataFromLocal(key);
    const updatedData = [...existingData, newItem];
    saveDataToLocal(key, updatedData);
    console.log(`✅ Added new item to ${key}, total items: ${updatedData.length}`);
    return updatedData;
  } catch (error) {
    console.error(`❌ Error adding data to ${key}:`, error);
    return [];
  }
};

export const updateDataInLocal = (key, updatedItem, idField) => {
  try {
    const existingData = getDataFromLocal(key);
    const updatedData = existingData.map(item =>
      item[idField] === updatedItem[idField] ? updatedItem : item
    );
    saveDataToLocal(key, updatedData);
    console.log(`✅ Updated item in ${key}`);
    return updatedData;
  } catch (error) {
    console.error(`❌ Error updating data in ${key}:`, error);
    return existingData;
  }
};

export const deleteDataFromLocal = (key, itemId, idField) => {
  try {
    const existingData = getDataFromLocal(key);
    const updatedData = existingData.filter(item => item[idField] !== itemId);
    saveDataToLocal(key, updatedData);
    console.log(`✅ Deleted item from ${key}, remaining items: ${updatedData.length}`);
    return updatedData;
  } catch (error) {
    console.error(`❌ Error deleting data from ${key}:`, error);
    return existingData;
  }
};

export const clearDataFromLocal = (key) => {
  try {
    localStorage.removeItem(key);
    console.log(`✅ Cleared ${key} from localStorage`);
  } catch (error) {
    console.error(`❌ Error clearing ${key} from localStorage:`, error);
  }
};

export const initializeDataIfEmpty = (key, defaultData) => {
  try {
    const existingData = getDataFromLocal(key);
    if (existingData.length === 0) {
      saveDataToLocal(key, defaultData);
      console.log(`✅ Initialized ${key} with default data (${defaultData.length} items)`);
      return defaultData;
    }
    console.log(`ℹ️ ${key} already has data (${existingData.length} items), skipping initialization`);
    return existingData;
  } catch (error) {
    console.error(`❌ Error initializing ${key}:`, error);
    return defaultData;
  }
};

